"use client";

import { SSpecificationDto } from "@/__generated__/graphql";
import CloseCircleBoldIcon from "@/app/_components/Icons/CloseCircleBoldIcon";
import TickCircleBoldIcon from "@/app/_components/Icons/TickCircleBoldIcon";
import { Box, Icon, Stack, Typography } from "@mui/material";
import ProductMidSectionSpecifications from "./ProductMidSectionSpecifications";
import ProductMobileScrollStrip from "./ProductMobileScrollStrip";

type Props = {
  specifications: SSpecificationDto[];
};

function specValue(specification: SSpecificationDto, truncate: boolean) {
  if (specification.type === "Boolean") {
    return (
      <Icon color={specification.checked ? "success" : "error"} sx={{ fontSize: 14, width: 16, height: 16 }}>
        {specification.checked ? <TickCircleBoldIcon /> : <CloseCircleBoldIcon />}
      </Icon>
    );
  }
  return (
    <Typography
      variant="caption"
      color="grey.900"
      noWrap
      sx={{ fontSize: "0.7rem", lineHeight: 1.35, maxWidth: truncate ? 96 : undefined }}
    >
      {specification.text}
    </Typography>
  );
}

export default function ProductMobileSpecsStrip({ specifications }: Props) {
  if (!specifications.length) return null;

  return (
    <ProductMobileScrollStrip
      title="مشخصات"
      viewAllLabel="همه"
      disclosure
      items={(truncate) =>
        specifications.map((specification, index) => (
          <Stack
            key={specification.id || index}
            spacing={0.15}
            sx={{
              minWidth: 88,
              maxWidth: truncate ? 110 : undefined,
              px: 1,
              py: 0.65,
              borderRadius: 1.5,
              bgcolor: "grey.A100",
              height: "100%",
            }}
          >
            <Typography variant="caption" color="grey.500" noWrap sx={{ fontSize: "0.65rem", lineHeight: 1.3 }}>
              {specification.title}
            </Typography>
            <Box sx={{ minHeight: 16, display: "flex", alignItems: "center" }}>
              {specValue(specification, truncate)}
            </Box>
          </Stack>
        ))
      }
      sheetContent={<ProductMidSectionSpecifications specifications={specifications} alwaysExpanded sheet />}
    />
  );
}
